module.exports = __webpack_public_path__ + "img/t1-21.36762528.png";